import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  OnInit
} from "@angular/core";

export interface ScrollTopOptions {
  offset: number;
  speed: number;
}

@Directive({
  selector: "[ktScrollTop]"
})
export class ScrollTopDirective {
  // Public properties
  @Input() options: ScrollTopOptions;
  // Private properites
  private scrollTop: any;
  private displaySroll: boolean;

  /**
   * Directive Conctructor
   * @param el: ElementRef
   */
  constructor(private el: ElementRef) {}

  /**
   * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
   */

  /**
   * After view init
   */
  ngAfterViewInit(): void {
    //this.scrollTop = new KTScrolltop(this.el.nativeElement, this.options);
  }

  /**
   * Returns ScrollTop
   */
  getScrollTop() {
    return this.scrollTop;
  }
}
